import React from 'react';
import { Link } from 'react-router-dom';
import { useLicense } from '../contexts/LicenseContext';
import { AlertTriangle } from 'lucide-react';

/**
 * Banner sutil no topo da app que avisa quando a licença local está próxima do
 * vencimento (<=7 dias). Só aparece quando REACT_APP_LICENSE_MODE=local
 * (via LicenseContext.showBanner). Fica invisível no modo cloud.
 */
export const LicenseBanner = () => {
  const { showBanner, status, daysRemaining, isLocalMode } = useLicense();
  if (!isLocalMode || !showBanner || !status?.active) return null;
  const critical = daysRemaining != null && daysRemaining <= 3;
  const cls = critical
    ? 'bg-red-600 text-white'
    : 'bg-amber-500 text-white';
  const label = critical
    ? `Licença vence em ${daysRemaining} dia(s)!`
    : `Licença vence em ${daysRemaining} dias.`;
  return (
    <div className={`${cls} px-4 py-2 flex items-center justify-between gap-3`} data-testid="license-banner">
      <div className="flex items-center gap-2 text-sm">
        <AlertTriangle size={16} />
        <span className="font-semibold">{label}</span>
        <span className="opacity-80 hidden md:inline">Renove com o fornecedor antes do bloqueio.</span>
      </div>
      <Link to="/license" className="text-xs underline hover:no-underline" data-testid="license-banner-link">
        Renovar agora →
      </Link>
    </div>
  );
};
